module.exports = __webpack_public_path__ + "static/SNGLIVE_Sponsor_Package-6aceb6c19ef4b1e18c9f5589bec14a3d.pdf";